module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8AQMAAACq8Y2NAAAABlBMVEXOEST////862ZCAAAAGElEQVQoz2P4DwIfGEYpKlFDBYxGFVUpAFx0OD8RYqY2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/gb-eng.png
// module id = v9yf
// module chunks = 0